export default __webpack_public_path__ + "static/media/3.7cec37f6.png";